import { useEffect, useState } from "react";
import api from "../../../api/axiosInstance";
import DataTable from "react-data-table-component";
import { MdEdit } from "react-icons/md";
import { Link } from "react-router-dom";
import { BsPlusCircleFill } from "react-icons/bs";
import CustomLoader from "../../../Components/custom/CustomLoader";
import PaginationControl from "../../../Components/custom/PaginationControl";
import Unauthorized from "../../../Components/custom/Unauthrized";
const ListRoles = (props) => {
  const [roles, setRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const columns = [
    {
      name: "Id",
      selector: (row) => row.roleId,
      width: "90px",
    },
    {
      name: "Name",
      selector: (row) => row.roleName,
    },
    {
      name: "Options",
      selector: (row) => (
        <>
          <Link
            to={"/Settings/Roles/" + row.roleId}
            className="btn btn-icons btn-primary btn-sm cts-btn-primary"
          >
            <MdEdit />{" "}
          </Link>
        </>
      ),
      width: "120px",
    },
  ];

  useEffect(() => {
    setIsLoading(true);
    var config = {
      method: "get",
      url: process.env.REACT_APP_API_URL + "Roles/GetRoles/",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };

    api(config).then(function (response) {
      if (response.data.statusCode === 200) {
        setRoles(response.data.content);
      }
      setIsLoading(false);
    });
  }, []);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
    setPage(1);
  };

  // Calculate paginated data
  const startIndex = (page - 1) * perPage;
  const endIndex = startIndex + perPage;
  const paginatedRoles = roles.slice(startIndex, endIndex);

  return (
    <>
      {props.userPermissions.viewRoles == false ? (
        <Unauthorized />
      ) : (
        <>
          <div className="container-fluid mt-30">
            <div className="row">
              <div className="col-12">
                <div className="card mb-3">
                  <div className="card-header">
                    <h3 className="card-title">Roles</h3>
                    <div className="align-self-center">
                      <Link
                        to="/Settings/Roles/0"
                        className="btn btn-primary btn-sm cts-btn-primary d-flex align-items-center gap-2"
                      >
                        <BsPlusCircleFill size={16} />
                        Add Roles
                      </Link>
                    </div>
                  </div>
                  <div className="card-body p-0">
                    <DataTable
                      data={paginatedRoles}
                      columns={columns}
                      progressPending={isLoading}
                      progressComponent={<CustomLoader />}
                      fixedHeader={true}
                      fixedHeaderScrollHeight={"620px"}
                      defaultSortFieldId={1}
                    />
                    <PaginationControl
                      totalCount={roles.length}
                      currentPage={page}
                      pageSize={perPage}
                      onPageChange={handlePageChange}
                      onPageSizeChange={handlePerRowsChange}
                      pageSizeOptions={[10, 20, 50, 100, 200]}
                      disabled={isLoading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ListRoles;
